<div *ngIf="model" class="np-form-control dx-fieldset mainInfos supplier-form">
  <!-- Scrollbarer Content -->
  <div class="np-supplier-content">
    <div class="container-fluid px-0">
      <div class="row g-3">
        <!-- Linke Spalte -->
        <div class="col-12 col-lg-6">
          <!-- SUPPLIER_NAME -->
          <div class="dx-field">
            <div class="dx-field-label dx-field-label200 supplier-label-row">
              <span>{{ 'Lieferantenname' | translate }}</span>

              <span
                  *ngIf="!existingSupplierSelectedBool"
                  class="dx-icon dx-icon-info info-icon"
                  id="supplierInfoIcon"
                  aria-label="Info"
                  role="img">
              </span>
            </div>

            <div class="dx-field-value">
              <dx-select-box
                  class="supplier-editor"
                  (onCustomItemCreating)="onCustomSupplierCreating($event)"
                  (onValueChanged)="catalogSupplierChanged($event)"
                  [searchEnabled]="true"
                  [(value)]="selectedDataSourceId"
                  [acceptCustomValue]="true"
                  [dataSource]="productDataSourceSuppliers"
                  [showClearButton]="true"
                  [width]="'100%'"
                  displayExpr="name"
                  placeholder=""
                  valueExpr="id">
              </dx-select-box>
            </div>
          </div>

          <dx-tooltip
              [closeOnOutsideClick]="false"
              hideEvent="mouseleave"
              showEvent="mouseenter"
              target="#supplierInfoIcon">
            <div>Kein passender Eintrag in den Datenquellen vorhanden.</div>
          </dx-tooltip>

          <!-- CONTACT -->
          <div class="dx-field">
            <div class="dx-field-label dx-field-label200">{{ 'Ansprechpartner' | translate }}</div>
            <div class="dx-field-value">
              <dx-text-box
                  (onValueChanged)="catalogChanged($event)"
                  [(value)]="model.supplier.address.contact"
                  [readOnly]="readOnlyUser('supplierAddresssContact')"
                  [showClearButton]="true"
                  valueChangeEvent="focusout">
              </dx-text-box>
            </div>
          </div>

          <!-- STREET -->
          <div class="dx-field">
            <div class="dx-field-label dx-field-label200">{{ 'Straße' | translate }}</div>
            <div class="dx-field-value">
              <dx-text-box
                  (onValueChanged)="catalogChanged($event)"
                  [(value)]="model.supplier.address.street"
                  [readOnly]="readOnlyUser('supplierAddressStreet')"
                  [showClearButton]="true"
                  valueChangeEvent="focusout">
              </dx-text-box>
            </div>
          </div>

          <!-- CITY -->
          <div class="dx-field">
            <div class="dx-field-label dx-field-label200">{{ 'Ort' | translate }}</div>
            <div class="dx-field-value">
              <dx-text-box
                  (onValueChanged)="catalogChanged($event)"
                  [(value)]="model.supplier.address.city"
                  [readOnly]="readOnlyUser('supplierAddressCity')"
                  [showClearButton]="true"
                  valueChangeEvent="focusout">
              </dx-text-box>
            </div>
          </div>

          <!-- PHONE -->
          <div class="dx-field">
            <div class="dx-field-label dx-field-label200">{{ 'Telefon' | translate }}</div>
            <div class="dx-field-value">
              <dx-text-box
                  (onValueChanged)="catalogChanged($event)"
                  [(value)]="model.supplier.address.phone"
                  [readOnly]="readOnlyUser('supplierAddressPhone')"
                  [showClearButton]="true"
                  valueChangeEvent="focusout">
              </dx-text-box>
            </div>
          </div>

          <!-- EMAIL -->
          <div class="dx-field">
            <div class="dx-field-label dx-field-label200">{{ 'E-Mail' | translate }}</div>
            <div class="dx-field-value">
              <dx-text-box
                  (onValueChanged)="catalogChanged($event)"
                  [(value)]="model.supplier.address.email"
                  [readOnly]="readOnlyUser('supplierAddressEmail')"
                  [showClearButton]="true"
                  valueChangeEvent="focusout">
              </dx-text-box>
            </div>
          </div>
        </div>

        <!-- Rechte Spalte -->
        <div class="col-12 col-lg-6">
          <!-- SUPPLIER_ID -->
          <div class="dx-field">
            <div class="dx-field-label dx-field-label200">{{ 'Lieferantenkennung' | translate }}</div>
            <div class="dx-field-value">
              <dx-text-box
                  (onValueChanged)="catalogChanged($event)"
                  [(value)]="model?.supplier.supplierId"
                  [readOnly]="readOnlyUser('supplierId')"
                  [showClearButton]="true"
                  valueChangeEvent="focusout">
              </dx-text-box>
            </div>
          </div>

          <!-- SUPPLIER_ID_TYPE -->
          <div class="dx-field">
            <div class="dx-field-label dx-field-label200">{{ 'Typ-ID' | translate }}</div>
            <div class="dx-field-value">
              <dx-autocomplete
                  (onValueChanged)="catalogChanged($event)"
                  [(value)]="model?.supplier.supplierIdType"
                  [dataSource]="idType"
                  [minSearchLength]="0"
                  [readOnly]="readOnlyUser('supplierType')"
                  [showClearButton]="true"
                  [showDropDownButton]="true"
                  valueChangeEvent="focusout">
              </dx-autocomplete>
            </div>
          </div>

          <!-- ZIP + STATE nebeneinander -->
          <div class="row g-3">
            <div class="col-12 col-md-6">
              <div class="dx-field">
                <div class="dx-field-label dx-field-label200">{{ 'PLZ' | translate }}</div>
                <div class="dx-field-value">
                  <dx-text-box
                      (onValueChanged)="catalogChanged($event)"
                      [(value)]="model.supplier.address.zip"
                      [readOnly]="readOnlyUser('supplierAddressZip')"
                      [showClearButton]="true"
                      valueChangeEvent="focusout">
                  </dx-text-box>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-6">
              <div class="dx-field">
                <div class="dx-field-label dx-field-label200">{{ 'Bundesland' | translate }}</div>
                <div class="dx-field-value">
                  <dx-text-box
                      (onValueChanged)="catalogChanged($event)"
                      [(value)]="model.supplier.address.state"
                      [readOnly]="readOnlyUser('supplierAddressState')"
                      [showClearButton]="true"
                      valueChangeEvent="focusout">
                  </dx-text-box>
                </div>
              </div>
            </div>
          </div>

          <!-- COUNTRY -->
          <div class="dx-field">
            <div class="dx-field-label dx-field-label200">{{ 'Land' | translate }}</div>
            <div class="dx-field-value">
              <dx-text-box
                  (onValueChanged)="catalogChanged($event)"
                  [(value)]="model.supplier.address.country"
                  [readOnly]="readOnlyUser('supplierAddressCountry')"
                  [showClearButton]="true"
                  valueChangeEvent="focusout">
              </dx-text-box>
            </div>
          </div>

          <!-- FAX -->
          <div class="dx-field">
            <div class="dx-field-label dx-field-label200">{{ 'Telefax' | translate }}</div>
            <div class="dx-field-value">
              <dx-text-box
                  (onValueChanged)="catalogChanged($event)"
                  [(value)]="model.supplier.address.fax"
                  [readOnly]="readOnlyUser('supplierAddressFax')"
                  [showClearButton]="true"
                  valueChangeEvent="focusout">
              </dx-text-box>
            </div>
          </div>

          <!-- URL -->
          <div class="dx-field">
            <div class="dx-field-label dx-field-label200">{{ 'Homepage' | translate }}</div>
            <div class="dx-field-value">
              <dx-text-box
                  (onValueChanged)="catalogChanged($event)"
                  [(value)]="model.supplier.address.url"
                  [readOnly]="readOnlyUser('supplierAddressUrl')"
                  [showClearButton]="true"
                  valueChangeEvent="focusout">
              </dx-text-box>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="dx-field">
            <div class="dx-field-label dx-field-label200">{{ 'Bemerkungen' | translate }}</div>
            <div class="dx-field-value">
              <dx-text-area
                  (onValueChanged)="catalogChanged($event)"
                  [(value)]="model.supplier.address.addressRemarks"
                  [readOnly]="readOnlyUser('supplierAddressRemarks')"
                  [autoResizeEnabled]="false"
                  [height]="120"
                  valueChangeEvent="focusout">
              </dx-text-area>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Fixer Footer -->
  <footer class="np-footer">
    <dx-button
        stylingMode="outlined"
        type="default"
        text="{{ 'Neuer Lieferant' | translate }}"
        [disabled]="readOnlyUser('supplierNew')"
        (onClick)="createNewDataSource()"
    ></dx-button>
  </footer>
</div>

<np-edit-datasource
    (saved)="onEditSaved($event)"
    [(visible)]="popupVisible"
    [dataSource]="newOrUpdateProductDataSource"
    [editMode]="isEdit"
    [relatedBrands]="relatedBrands">
</np-edit-datasource>
